import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CentralCatalogueService } from '../../../services/central-catalogue/central-catalogue.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// add or edit an organisation (the top of the central inventory tree). self-saving.
@Component({
  selector: 'app-cc-org-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './cc-org-dialog.component.html',
  styleUrls: ['../cc-dialog-form.scss', '../../../../common-style/ac-dialog.scss'],
})
export class CcOrgDialogComponent {
  form: FormGroup;
  isLoading: boolean = false;
  isEdit: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CcOrgDialogComponent>,
    private catalogueService: CentralCatalogueService,
    private toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: { organisation?: any }
  ) {
    const org = this.data?.organisation;
    this.isEdit = !!org;
    this.form = this.fb.group({
      name: [org?.name || '', Validators.required],
      description: [org?.description || '', Validators.required],
      address: [org?.address || '', Validators.required],
      contactNumber: [org?.contactNumber || '', Validators.required],
      altContactNumber: [org?.altContactNumber || ''],
      status: [org?.status || 'ACTIVE', Validators.required],
    });
  }

  get title(): string {
    return this.isEdit ? 'Edit organisation' : 'Add organisation';
  }

  submit(): void {
    if (this.form.invalid) {
      this.toastService.error('Name, description, address and contact number are required.');
      return;
    }
    this.isLoading = true;
    const payload = this.form.value;
    const request = this.isEdit
      ? this.catalogueService.updateOrganisation(this.data.organisation.orgId, payload)
      : this.catalogueService.addOrganisation(payload);

    request.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Saved.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save the organisation.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
